import React from 'react';
import './service-call-support.scss';
import MailSpan from '../../../shared/MailSpan';
import { useTranslation } from 'react-i18next';
import { Mail, PhoneCall } from 'react-feather';
import PhoneSpan from '../../../shared/PhoneSpan/PhoneSpan';
import { useGetLocation } from '../../../../store/RoomManagement/resourceManagementHooks';

const ServiceCallSupport = () => {
  const { t } = useTranslation();
  const location = useGetLocation();

  return (
    <div className="service-call-support">
      <div className="service-call-support-title">
        {t('SERVICE_CALL_SUPPORT')}
      </div>
      <div className="service-call-support-details-phone">
        <PhoneCall />
        <PhoneSpan phone={location?.support?.phone}  dir={'ltr'}/>
      </div>
      <div className="service-call-support-details-mail">
        <Mail />
        <MailSpan mail={location?.support?.email} />
      </div>
    </div>
  );
};

export default ServiceCallSupport;
